<ul class="ap-header__user-navigation" role="menu">
    @if (isLoggedIn() && profileMenu()) {
        <li role="menuitem" data-testid="header-horizontal-profile-menu-item">
            <ap-popover position="right" data-testid="header-horizontal-profile-menu-popover">
                <span ap-popover-parent class="ap-header__user-navigation-item">
                    <ap-icon name="user" size="medium"> </ap-icon>
                    <span class="ap-header__username">{{ profileMenu().name }}</span>
                    @if (profileMenu().notifications) {
                        <ap-badge class="ap-header__badge" data-testid="header-horizontal-profile-notifications">{{
                            profileMenu().notifications
                        }}</ap-badge>
                    }
                    <ap-icon class="ap-header__navigation-chevron--down" name="chevron-down-animated" color="inherit" size="small">
                    </ap-icon>
                </span>
                <div ap-popover-content class="ap-header__user-navigation-dropdown" aria-haspopup="true">
                    <ap-profile-menu
                        [profileMenu]="profileMenu()"
                        (loginLogout)="loginLogout.emit($event)"
                        (itemClicked)="itemClicked.emit($event)"
                    ></ap-profile-menu>
                </div>
            </ap-popover>
        </li>
    }
    <li class="ap-header__user-navigation-item" role="menuitem" data-testid="header-horizontal-login-item">
        <a
            tabindex="0"
            (keydown.enter)="loginLogout.emit(isLoggedIn())"
            (keydown.space)="loginLogout.emit(isLoggedIn())"
            (click)="loginLogout.emit(isLoggedIn())"
            data-testid="header-horizontal-login-button"
        >
            @if (isLoggedIn()) {
                <span class="ap-sr-only">{{ 'header.logout' | apContent }}</span>
                <ap-icon name="logout" size="large"></ap-icon>
            } @else {
                {{ 'header.login' | apContent }}
            }
        </a>
    </li>
</ul>
